/* istanbul ignore next */
/**
 * Simple `window.scrollY` getter for easier mocking in tests
 */
export const getWindowScrollY = () => window.scrollY;
